export default __webpack_public_path__ + "static/yonce-bash-it-terminal-screenshot-c89924c2bbde3d0452db2d6cd8275bf5.png";